import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

// Usuń import nieistniejącej czcionki
// import '@/assets/fonts/Roboto-Regular-normal';

// Funkcja formatowania waluty
function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}

// Funkcja do konwersji polskich znaków dla PDF
function convertPolishChars(text: string): string {
  if (!text) return '';
  
  // Mapa polskich znaków na ich odpowiedniki
  const polishChars: { [key: string]: string } = {
    'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 
    'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
    'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N',
    'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z'
  };
  
  // Zamień polskie znaki
  return text.split('').map(char => polishChars[char] || char).join('');
}

// Alternatywna metoda - użyj Unicode
function setupPolishFont(doc: jsPDF) {
  // Ustaw font który wspiera Unicode
  doc.setFont('helvetica', 'normal');
  
  // Alternatywnie możemy dodać własną czcionkę
  // ale to wymaga dodatkowej konfiguracji
}

export function generatePayrollPDF(reportData: any[], month: string) {
  const doc = new jsPDF();
  setupPolishFont(doc);
  
  const pageWidth = doc.internal.pageSize.width;
  
  // Nagłówek
  doc.setFontSize(20);
  doc.setTextColor(255, 111, 0);
  doc.text('Rozliczenie Miesieczne', pageWidth / 2, 20, { align: 'center' });
  
  // Data
  doc.setFontSize(12);
  doc.setTextColor(100, 100, 100);
  const monthName = new Date(month + '-01').toLocaleDateString('pl-PL', { 
    year: 'numeric', 
    month: 'long' 
  });
  doc.text(`Miesiac: ${convertPolishChars(monthName)}`, pageWidth / 2, 30, { align: 'center' });
  
  // Data generowania
  doc.setFontSize(10);
  doc.text(`Data wygenerowania: ${new Date().toLocaleDateString('pl-PL')}`, 14, 40);
  
  // Tabela z danymi pracowników
  const tableData = reportData.map(data => [
    convertPolishChars(`${data.employee.firstName} ${data.employee.lastName}`),
    data.workDays,
    data.totalHours + 'h',
    formatCurrency(data.payment).replace('zł', 'PLN'),
    formatCurrency(data.payment * 0.77).replace('zł', 'PLN')
  ]);
  
  // @ts-ignore
  doc.autoTable({
    startY: 50,
    head: [['Pracownik', 'Dni pracy', 'Godziny', 'Brutto', 'Netto (szac.)']],
    body: tableData,
    theme: 'grid',
    styles: {
      fontSize: 10,
      cellPadding: 5,
      font: 'helvetica'
    },
    headStyles: {
      fillColor: [255, 111, 0],
      textColor: 255
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245]
    }
  });
  
  // Podsumowanie
  const totalGross = reportData.reduce((sum, data) => sum + data.payment, 0);
  const totalNet = totalGross * 0.77;
  
  // @ts-ignore
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.text('Podsumowanie:', 14, finalY);
  
  // @ts-ignore
  doc.autoTable({
    startY: finalY + 5,
    body: [
      [`Liczba pracownikow:`, reportData.length],
      [`Laczne wynagrodzenie brutto:`, formatCurrency(totalGross).replace('zł', 'PLN')],
      [`Laczne wynagrodzenie netto (szac.):`, formatCurrency(totalNet).replace('zł', 'PLN')],
      [`Srednie wynagrodzenie:`, formatCurrency(reportData.length > 0 ? totalGross / reportData.length : 0).replace('zł', 'PLN')]
    ],
    theme: 'plain',
    styles: {
      fontSize: 11,
      font: 'helvetica'
    }
  });
  
  // Stopka
  const pageHeight = doc.internal.pageSize.height;
  doc.setFontSize(8);
  doc.setTextColor(150, 150, 150);
  doc.text('PlexiSystem - System Zarzadzania', pageWidth / 2, pageHeight - 10, { align: 'center' });
  
  // Zapisz PDF
  doc.save(`rozliczenie_${month}.pdf`);
}

export function generateIndividualPayslip(
  employee: any,
  calculation: any,
  month: string
) {
  const doc = new jsPDF();
  setupPolishFont(doc);
  const pageWidth = doc.internal.pageSize.width;
  
  // Nagłówek
  doc.setFontSize(16);
  doc.setTextColor(255, 111, 0);
  doc.text('PASEK WYNAGRODZEN', pageWidth / 2, 20, { align: 'center' });
  
  // Dane firmy
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text('PlexiSystem Sp. z o.o.', 14, 35);
  doc.text('ul. Przykladowa 123', 14, 40);
  doc.text('00-000 Warszawa', 14, 45);
  doc.text('NIP: 123-456-78-90', 14, 50);
  
  // Dane pracownika
  doc.setFontSize(12);
  doc.text('Dane pracownika:', 14, 65);
  doc.setFontSize(10);
  doc.text(`Imie i nazwisko: ${convertPolishChars(employee.firstName + ' ' + employee.lastName)}`, 14, 72);
  doc.text(`Stanowisko: ${convertPolishChars(employee.position || 'Pracownik')}`, 14, 77);
  const monthText = new Date(month + '-01').toLocaleDateString('pl-PL', { year: 'numeric', month: 'long' });
  doc.text(`Okres: ${convertPolishChars(monthText)}`, 14, 82);
  
  // Tabela wynagrodzeń
  const salaryData = [
    ['Wynagrodzenie zasadnicze', formatCurrency(calculation.base_salary || 0).replace('zł', 'PLN')]
  ];
  
  if (calculation.overtime_pay_50 > 0) {
    salaryData.push(['Nadgodziny 50%', formatCurrency(calculation.overtime_pay_50).replace('zł', 'PLN')]);
  }
  if (calculation.overtime_pay_100 > 0) {
    salaryData.push(['Nadgodziny 100%', formatCurrency(calculation.overtime_pay_100).replace('zł', 'PLN')]);
  }
  if (calculation.night_pay > 0) {
    salaryData.push(['Dodatek nocny', formatCurrency(calculation.night_pay).replace('zł', 'PLN')]);
  }
  
  salaryData.push(['WYNAGRODZENIE BRUTTO', formatCurrency(calculation.gross_salary || 0).replace('zł', 'PLN')]);
  
  // @ts-ignore
  doc.autoTable({
    startY: 95,
    head: [['Skladnik wynagrodzenia', 'Kwota']],
    body: salaryData,
    theme: 'grid',
    styles: {
      fontSize: 10,
      font: 'helvetica'
    },
    headStyles: {
      fillColor: [255, 111, 0]
    },
    footStyles: {
      fillColor: [240, 240, 240],
      textColor: [0, 0, 0],
      fontStyle: 'bold'
    }
  });
  
  // Tabela potrąceń
  // @ts-ignore
  const potrY = doc.lastAutoTable.finalY + 10;
  
  const deductionsData = [
    ['Skladka emerytalna (9.76%)', formatCurrency(calculation.pension_contribution || 0).replace('zł', 'PLN')],
    ['Skladka rentowa (1.5%)', formatCurrency(calculation.disability_contribution || 0).replace('zł', 'PLN')],
    ['Skladka chorobowa (2.45%)', formatCurrency(calculation.sickness_contribution || 0).replace('zł', 'PLN')],
    ['Skladka zdrowotna (9%)', formatCurrency(calculation.health_contribution || 0).replace('zł', 'PLN')],
    ['Zaliczka na podatek dochodowy', formatCurrency(calculation.income_tax || 0).replace('zł', 'PLN')],
    ['SUMA POTRACEN', formatCurrency(
      (calculation.pension_contribution || 0) + 
      (calculation.disability_contribution || 0) + 
      (calculation.sickness_contribution || 0) + 
      (calculation.health_contribution || 0) + 
      (calculation.income_tax || 0)
    ).replace('zł', 'PLN')]
  ];
  
  // @ts-ignore
  doc.autoTable({
    startY: potrY,
    head: [['Potracenia', 'Kwota']],
    body: deductionsData,
    theme: 'grid',
    styles: {
      fontSize: 10,
      font: 'helvetica'
    },
    headStyles: {
      fillColor: [200, 200, 200]
    },
    footStyles: {
      fillColor: [240, 240, 240],
      textColor: [0, 0, 0],
      fontStyle: 'bold'
    }
  });
  
  // Do wypłaty
  // @ts-ignore
  const netY = doc.lastAutoTable.finalY + 15;
  doc.setFontSize(14);
  doc.setTextColor(0, 150, 0);
  doc.text(`DO WYPLATY: ${formatCurrency(calculation.net_salary || 0).replace('zł', 'PLN')}`, pageWidth / 2, netY, { align: 'center' });
  
  // Podpisy
  const signY = netY + 30;
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text('..........................................', 30, signY);
  doc.text('..........................................', pageWidth - 70, signY);
  doc.setFontSize(8);
  doc.text('Podpis pracodawcy', 30, signY + 5);
  doc.text('Podpis pracownika', pageWidth - 70, signY + 5);
  
  // Stopka
  const pageHeight = doc.internal.pageSize.height;
  doc.setFontSize(8);
  doc.setTextColor(150, 150, 150);
  doc.text(`Wygenerowano: ${new Date().toLocaleString('pl-PL')}`, pageWidth / 2, pageHeight - 10, { align: 'center' });
  
  // Zapisz PDF
  doc.save(`pasek_${convertPolishChars(employee.lastName)}_${month}.pdf`);
}

export function generateAnnualReport(
  employees: any[],
  year: number,
  monthlyData: any[]
) {
  const doc = new jsPDF('l'); // Orientacja pozioma
  setupPolishFont(doc);
  const pageWidth = doc.internal.pageSize.width;
  
  // Nagłówek
  doc.setFontSize(20);
  doc.setTextColor(255, 111, 0);
  doc.text(`Roczne zestawienie wynagrodzen ${year}`, pageWidth / 2, 20, { align: 'center' });
  
  // Tabela z danymi rocznymi
  const tableData = employees.map(employee => {
    const employeeData = monthlyData.filter(d => d.employeeId === employee.id);
    const totalGross = employeeData.reduce((sum, d) => sum + d.grossAmount, 0);
    const totalNet = employeeData.reduce((sum, d) => sum + d.netAmount, 0);
    const months = employeeData.length;
    
    return [
      convertPolishChars(`${employee.firstName} ${employee.lastName}`),
      months,
      formatCurrency(totalGross).replace('zł', 'PLN'),
      formatCurrency(totalNet).replace('zł', 'PLN'),
      formatCurrency(months > 0 ? totalGross / months : 0).replace('zł', 'PLN'),
      formatCurrency(months > 0 ? totalNet / months : 0).replace('zł', 'PLN')
    ];
  });
  
  // @ts-ignore
  doc.autoTable({
    startY: 35,
    head: [['Pracownik', 'Mies.', 'Brutto (rok)', 'Netto (rok)', 'Sr. brutto', 'Sr. netto']],
    body: tableData,
    theme: 'grid',
    styles: {
      fontSize: 9,
      cellPadding: 3,
      font: 'helvetica'
    },
    headStyles: {
      fillColor: [255, 111, 0]
    }
  });
  
  // Podsumowanie
  const totalGrossYear = monthlyData.reduce((sum, d) => sum + d.grossAmount, 0);
  const totalNetYear = monthlyData.reduce((sum, d) => sum + d.netAmount, 0);
  
  // @ts-ignore
  const summaryY = doc.lastAutoTable.finalY + 15;
  doc.setFontSize(12);
  doc.text('Podsumowanie roczne:', 14, summaryY);
  
  // @ts-ignore
  doc.autoTable({
    startY: summaryY + 5,
    body: [
      ['Laczna kwota brutto:', formatCurrency(totalGrossYear).replace('zł', 'PLN')],
      ['Laczna kwota netto:', formatCurrency(totalNetYear).replace('zł', 'PLN')],
      ['Srednia miesieczna brutto:', formatCurrency(totalGrossYear / 12).replace('zł', 'PLN')],
      ['Srednia miesieczna netto:', formatCurrency(totalNetYear / 12).replace('zł', 'PLN')]
    ],
    theme: 'plain',
    styles: {
      fontSize: 11,
      font: 'helvetica'
    }
  });
  
  // Zapisz PDF
  doc.save(`zestawienie_roczne_${year}.pdf`);
}
